export const createState = () => ({
    id: null,
    communityId: null,
    title: '',
    description: '',
    status: 'draft',
    starts: null,
    ends: null,
    ticketsUrl: null,
    ticketsNote: null,
    ticketsOnSale: null,
    heroAttachmentId: null,
    themeSettings: [],
    stops: [],
    faqs: [],
});
// communityId is a create-time choice only, so an edit leaves it unset and the update ignores it.
export const toForm = (tour) => ({
    id: tour.id,
    communityId: null,
    title: tour.title,
    description: tour.description,
    status: tour.status,
    starts: tour.starts,
    ends: tour.ends,
    ticketsUrl: tour.ticketsUrl,
    ticketsNote: tour.ticketsNote,
    ticketsOnSale: tour.ticketsOnSale,
    heroAttachmentId: tour.heroAttachmentId,
    themeSettings: tour.themeSettings,
    stops: tour.stops.map(stop => ({ propertyId: stop.propertyId, parcelViewId: stop.parcelViewId })),
    faqs: tour.faqs.map(faq => ({ question: faq.question, answer: faq.answer })),
});
